import {globalStateContext} from '@/App.jsx';
import {MyView} from '@/styles';
import React from 'react';
import Filter from './Filter.jsx';
import AdvisorMenu from './menus/AdvisorMenu.jsx';
import Agent from './menus/Agent.jsx';
import SchoolMenu from './menus/SchoolMenu.jsx';
import StudentMenu from './menus/Student.jsx';
import Teacher from './menus/Teacher.jsx';
const Menu = props => {
  const useGlobalState = () => [React.useContext(globalStateContext)];
  const [state] = useGlobalState();

  return (
    <MyView
      className="menu-item-container-parent"
      style={{
        width: state.isInPhone ? '100%' : 'unset',
      }}>
      {state.isRightMenuVisible && props.accesses !== null && (
        <>
          {(props.accesses.indexOf('student') !== -1 ||
            props.accesses.indexOf('admin') !== -1) && (
            <StudentMenu selected={props.selected} navigate={props.navigate} />
          )}
          {props.accesses.indexOf('agent') !== -1 && (
            <Agent selected={props.selected} navigate={props.navigate} />
          )}
          {props.accesses.indexOf('school') !== -1 && (
            <SchoolMenu selected={props.selected} navigate={props.navigate} />
          )}
          {props.accesses.indexOf('advisor') !== -1 && (
            <AdvisorMenu
              hasTeacherAccess={props.accesses.indexOf('teacher') !== -1}
              selected={props.selected}
              navigate={props.navigate}
            />
          )}

          {props.accesses.length === 1 &&
            props.accesses.indexOf('teacher') !== -1 && (
              <Teacher selected={props.selected} navigate={props.navigate} />
            )}
        </>
      )}
      {props.isFilterAvailable &&
        !state.isRightMenuVisible &&
        state.isFilterMenuVisible && <Filter />}
    </MyView>
  );
};
export default Menu;
